import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class TipoIdentificacaoService {

  constructor(public http: HttpClient) { }

  findTipoIdentificacao(): Observable<any> {
    return this.http.get('assets/tipoIdentificacao.json');
  }

}
